import { createAction, props } from '@ngrx/store';
import { Invite } from '@fc-core';

export const invitesError = createAction(
  '[Invite/API] Invites Error',
  props<{ error: any }>(),
);

export const loadInvites = createAction('[Invite/API] Load Invites');
export const loadInvitesSuccess = createAction(
  '[Invite/API] Load Invites Success',
  props<{ invites: Invite[]; count: number }>(),
);

export const addInvite = createAction(
  '[Invite/api] Add Invite',
  props<{ invite: Invite }>(),
);
export const addInviteSuccess = createAction(
  '[Invite/api] Add Invite Success',
  props<{ invite: Invite }>(),
);

export const deleteInvite = createAction(
  '[Invite/api] Delete Invite',
  props<{ inviteId: number }>(),
);
export const deleteInviteSuccess = createAction(
  '[Invite/api] Delete Invite Success',
  props<{ inviteId: number }>(),
);

// export const convertInviteToUser = createAction(
//   '[Invite/api] Convert Invite To User',
//   props<{ user: User }>(),
// );
// export const convertInviteToUserSuccess = createAction(
//   '[Invite/api] Convert Invite To User Success',
//   props<{ user: User; inviteId: number }>(),
// );

export const resendInvite = createAction(
  '[Invite/api] Resend Invite',
  props<{ inviteId: number; employee: string }>(),
);
export const resendInviteSuccess = createAction(
  '[Invite/api] Resend Invite Success',
);
